import styled from 'styled-components';

export const ChooserPageContainer = styled.div`
  display: grid;
  grid-auto-columns: minmax(auto, 802px);
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  background: ${({ theme }) => theme.color.ui.grey[10]};
`;

export const Heading = styled.h1`
  font-size: 28px;
  line-height: 40px;
  font-weight: 500;
  margin-bottom: 0px;
  color: ${({ theme }) => theme.color.ui.grey[100]};
`;

export const Text = styled.p`
  font-size: 16px;
  line-height: 20px;
  font-weight: ${props => (props.bold ? '500' : 'normal')};
  margin-top: ${props => (props.bold ? '16px' : '8px')};
  color: ${props => (props.bold ? props.theme.color.ui.grey[100] : props.theme.color.ui.grey[90])};
`;

export const ContentContainer = styled.div``;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-top: 32px;
  margin-bottom: 32px;

  @media (${({ theme }) => theme.media.tabletPortraitMax}) {
    grid-template-columns: 1fr;
  }
`;
